<template>
  <section class="section users-detail" v-if="resource">
    <div class="columns">
      <div class="column is-half">
        <div class="card has-text-centered">
          <div class="card-content">
            <figure class="image is-96x96 container">
              <img
                :src="cloud(resource.profilePic)"
                alt="Placeholder image"
                class="is-rounded"
                @error="imageUrlAlt"
              />
            </figure>
            <div style="margin-top: 2.5em">
              <h3>{{ resource.$getFullName() }}</h3>
              <h5>{{ resource.username }}</h5>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-half">
        <div class="columns is-mobile">
          <can :I="$A.OWN" :this="resource">
            <div class="column">
              <div class="card">
                <header class="card-header">
                  <h5 class="card-header-title">
                    Payment Information
                  </h5>
                </header>
                <div class="card-content has-text-left">
                  <div class="content is-medium">
                    <h5>Credit Card</h5>
                    <p>Your credit cards will appear here.</p>
                    <h5>PayPal</h5>
                    <p>Your PayPal login will appear here.</p>
                  </div>
                </div>
              </div>
            </div>
          </can>

          <div class="column">
            <div class="card">
              <header class="card-header">
                <h5 class="card-header-title">{{ pronoun }} Information</h5>
                <div
                  class="card-header-icon"
                  v-if="$can($A.PATCH, resource) || $can($A.PATCH, $R.USERS)"
                >
                  <router-link :to="`/users/${resource.username}/edit`">
                    <b-icon icon="edit-2" size="is-small" />
                  </router-link>
                </div>
              </header>
              <div class="card-content has-text-left">
                <div class="content is-medium">
                  <div
                    v-if="$can($A.PATCH, resource) || $can($A.PATCH, $R.USERS)"
                  >
                    <h5>Email</h5>
                    <p style="margin-bottom: 1em;">{{ resource.email }}</p>
                  </div>
                  <h5>Joined On</h5>
                  <p>{{ resource.createdAt | long_date }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="card">
          <header class="card-header no-shadow" style="border: 0">
            <b-tabs
              v-model="activeTab"
              expanded
              animation="slide-next"
              class="no-bottom-margin"
              :animated="true"
            >
              <b-tab-item label="Favorites" icon="heart">
                <div v-if="favorites.length">
                  <h-webapps-card-container>
                    <div v-for="(content, index) in favorites" :key="index">
                      <div
                        :flip="content.targetIndex === `spaces`"
                        :is="`h-${content.targetIndex}-card`"
                        :content="content"
                        :width="`125px`"
                        :hasText="false"
                        :hasBadge="true"
                        :tilt="true"
                        :shake="true"
                        :index="index"
                      />
                    </div>
                  </h-webapps-card-container>
                </div>
                <p v-else>No collections yet.</p>
              </b-tab-item>
              <b-tab-item label="Pictures" icon="image">
                <div class="masonry">
                  <a
                    v-for="pic in pics"
                    :key="pic.src"
                    class="item"
                    @click="launchPicDetail(pic)"
                  >
                    <img :src="cloud(pic.src)" :alt="pic.alternateText" />
                  </a>
                </div>
              </b-tab-item>
              <b-tab-item label="Videos" icon="video">
                Lorem ipsum dolor sit amet.
              </b-tab-item>
              <b-tab-item label="Audio" icon="speaker">
                Lorem ipsum dolor sit amet.
              </b-tab-item>
              <b-tab-item label="Text" icon="type">
                Lorem ipsum dolor sit amet.
              </b-tab-item>
            </b-tabs>
          </header>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </section>
</template>

<script>
import * as cards from "@/components/base/resourceCards.js";
import HWebappsCardContainer from "@/components/webapps/HWebappsCardContainer";
import { resourceModules } from "@/common/resources/index.js";
import { mapGetters } from "vuex";
import { resolveSingle } from "@/common/route.service";
import { showModal } from "@/common/modal.service";
import picturesModal from "@/components/pictures/PicturesModal.vue";

export default {
  name: "users-detail",
  components: {
    ...cards,
    HWebappsCardContainer,
  },
  data() {
    return {
      favorites: [],
      resource: undefined,
      pronoun: undefined,
      pics: undefined,
      activeTab: undefined,
    };
  },
  methods: {
    //This is used in the event that the url is no longer valid
    imageUrlAlt(event) {
      event.target.src = this.cloud(`avatar.png`);
    },
    async setInfo() {
      this.resource = this.$route.meta.data;
      this.pronoun = this.$can(this.$A.OWN, this.resource) ? "Your" : "Their";
    },
    launchPicDetail(pic) {
      showModal({
        props: { resource: pic },
        hasModalCard: true,
        overflow: true,
        component: picturesModal,
        parent: this,
        onCancel: e => console.log("Closed via button: ", e),
        events: {
          close: e => console.log("Closed via button: ", e),
        },
      });
    },
  },
  watch: {
    async resource() {
      this.favorites = [];
      (await this.resource.$getFavorites()).data.forEach(async fav => {
        // Redundant fields on the favorite doc are just enough to show the card UI, create Resource from it.  targetID becomes the id
        const content = Object.assign(fav, { id: fav.targetID });
        this.favorites.push(new resourceModules[fav.targetIndex](content));
      });

      this.pics = (await resourceModules.pictures.all()).data;
    },
  },
  async created() {
    await this.setInfo();
  },
  async updated() {
    await this.setInfo();
  },
  beforeRouteUpdate() {
    resolveSingle.bind({ type: "Users" })(...arguments);
  },
  computed: {
    ...mapGetters(["currentUser"]),
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/bulma_overrides.scss";

.no-shadow {
  // since card-header occupies the entire card here, we get double box-shadow (one from .card and one from .card-header).  Remove the one on card-header to prefer .card's (since to the user, it just looks like a card)
  box-shadow: none;
}
.image img {
  height: 100%;
  object-fit: cover;
}

.masonry {
  /* Masonry container */
  column-count: 4;
  column-gap: 1em;
}
.item {
  /* Masonry bricks or child elements */
  display: block;
  margin: 0 0 1em;
  width: 100%;
}

.masonry img {
  border-radius: $radius-large;
}
</style>
